module.exports = __webpack_public_path__ + "static/img/manual_zh_6.4632d3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_6.png
// module id = LFiq
// module chunks = 4